/// <amd-module name="TFS/Samples/ThemeGenerator/ColorUtil" />

export function parsePaletteColor(paletteValue: string): number[] | undefined {
    const paletteMatch = new RegExp(/([0-9]+),\s*([0-9]+),\s*([0-9]+)/gim).exec(paletteValue);
    if (paletteMatch) {
        return [parseInt(paletteMatch[1]), parseInt(paletteMatch[2]), parseInt(paletteMatch[3])];
    } else {
        return undefined;
    }
}

export function paletteToHexColor(paletteValue: string): string | undefined {
    const colors = parsePaletteColor(paletteValue);
    if (colors) {
        return "#" + toHexTwoDigits(colors[0]) + toHexTwoDigits(colors[1]) + toHexTwoDigits(colors[2]);
    } else {
        return undefined;
    }
}

function toHexTwoDigits(number: number): string {
    const result = number.toString(16);
    return result.length > 1 ? result : "0" + result;
}

export function toPaletteColor(colorStr: string): string {
    if (colorStr[0] === "#") {
        return hexToPaletteColor(colorStr);
    } else {
        const rgbMatch = new RegExp(/rgb[a]?\(([0-9]+,\s*[0-9]+,\s*[0-9]+)[,\)]+/gim).exec(colorStr);
        if (rgbMatch) {
            return rgbMatch[1];
        } else {
            return colorStr;
        }
    }
}

function fromHex(hexStr: string): string {
    return parseInt(hexStr, 16).toString(10);
}

export function hexToPaletteColor(hexStr: string): string {
    let trimmedHexStr = hexStr.trim();
    if (trimmedHexStr[0] === "#") {
        trimmedHexStr = trimmedHexStr.substr(1);
    }

    if (trimmedHexStr.length === 6) {
        return `${fromHex(trimmedHexStr.substr(0, 2))}, ${fromHex(trimmedHexStr.substr(2, 2))}, ${fromHex(trimmedHexStr.substr(4, 2))}`;
    } else {
        return hexStr;
    }
}

export function darkenPaletteColor(paletteColor: string, pct: number) {
    const result = paletteColor;
    const colors = parsePaletteColor(paletteColor);
    if (colors) {
        return [Math.round(colors[0] * pct), Math.round(colors[1] * pct), Math.round(colors[2] * pct)].join(", ");
    }
    return result;
}

export function lightenPaletteColor(paletteColor: string, pct: number) {
    const result = paletteColor;
    const colors = parsePaletteColor(paletteColor);
    if (colors) {
        return [Math.round(255 - (255 - colors[0]) * pct), Math.round(255 - (255 - colors[1]) * pct), Math.round(255 - (255 - colors[2]) * pct)].join(
            ", "
        );
    }
    return result;
}
